import{useContext}from"react";import{CheckboxGroupContext}from"../CheckboxGroup";export const useCheckboxGroup=()=>useContext(CheckboxGroupContext);